import React from 'react';
import { ChatMessageTemplateProps } from '@progress/kendo-react-conversational-ui';
import { ChatReasoningSection } from './ChatReasoningSection';
import { ChatSourcesSection } from './ChatSourcesSection';
import { ChatSummary } from './ChatSummary';
import { ChatImageGrid } from './ChatImageGrid';
import { VegaLiteChart } from '../../../../common/components/VegaLiteChart';

const vegaDefaults = { width: 400, height: 300 };

export const AIMessageTemplate: React.FC<ChatMessageTemplateProps> = ({ item }) => {
    const { dataItem } = item;
    const isLoading = dataItem.isLoading ?? false;
    return (
        <>
            {dataItem.reasoning && (
                <ChatReasoningSection
                    reasoning={dataItem.reasoning}
                    isLoading={isLoading}
                />
            )}

            {dataItem.summary && (
                <ChatSummary summary={dataItem.summary} citationLinks={dataItem.citationLinks} />
            )}

            {dataItem.answerUrls && dataItem.answerUrls.length > 0 && (
                <ChatImageGrid imageUrls={dataItem.answerUrls} />
            )}

            {dataItem.dataVisualizations && dataItem.dataVisualizations.length > 0 && (
                <div className="chat-visualizations">
                    {dataItem.dataVisualizations.map((viz: { vega_lite_obj: any; }, index: React.Key | null | undefined) => (
                        <VegaLiteChart key={index} spec={{...vegaDefaults, ...viz.vega_lite_obj}} />
                    ))}
                </div>
            )}

            {dataItem.sources && dataItem.sources.length > 0 && (
                <ChatSourcesSection sources={dataItem.sources} />
            )}
        </>
    );
};
